import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Breadcrumb as RBBreadcrumb,
} from 'react-bootstrap';

const ManualBreadcrumb = ({ children }) => {
  return (
    <Container>
      <RBBreadcrumb>{children}</RBBreadcrumb>
    </Container>
  );
};

ManualBreadcrumb.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ManualBreadcrumb;
